const styles = {
  container: {
    maxHeight: 850,
    overflow: "auto",
  },
  avatar: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "start",
    height: 40,
    width: 40,
    borderRadius: "50%",
  },
  listItem: {
    display: "flex",
    gap: 14,
    paddingBottom: 2,
  },
  reverseItem: {
    flexDirection: "row-reverse",
  },
  remarkText: {
    backgroundColor: "#F5F5F7",
    padding: "6px 10px 6px",
    borderRadius: "10px 10px 10px 0px",
    minHeight: "42px",
    maxWidth: "337px",
    fontSize: "10px",
    minWidth: "60px",
    width: "100%",
  },
  reverseRemarkText: {
    backgroundColor: "#D6F0FF",
    borderRadius: "10px 10px 0px 10px",
  },
  time: {
    display: "flex",
    justifyContent: "flex-end",
    marginRight: "18px",
  },
  reverseTime: {
    justifyContent: "flex-start",
  },
};

export default styles;
